import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 0 5px 5px 5px;
  margin-bottom: 10px;
`
